import { render, staticRenderFns } from "./package-card.vue?vue&type=template&id=53129dd7&scoped=true&"
import script from "./package-card.vue?vue&type=script&lang=js&"
export * from "./package-card.vue?vue&type=script&lang=js&"
import style0 from "./package-card.vue?vue&type=style&index=0&id=53129dd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53129dd7",
  null
  
)

export default component.exports